import Dnd from '../../grid/dnd';

export default instance => {
  instance.attachEvent('onRowDragMove', (id, targetId, targetIndex) => Dnd.onRowDragMove(id, targetId, targetIndex));
};
